import { useState } from 'react';
import { BASE_URL } from '../config';

export const useRecoverPassword = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetcher = async (request = { endpoint: '', data: {}, body: {}, method: "GET" }) => {
        setLoading(true);
        const { endpoint = '', data, body, method = "GET" } = request;
        try {
            const res = await fetch(`${BASE_URL}${endpoint}`, {
                method,
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                },
                body,
                data
            });
            if (!res) throw new Error('Algo salio mal');
            return await res.json();
        } catch (err) {
            setError(err.message);
            throw new Error(err.message);
        } finally {
            setLoading(false);
        }
    }

    const requestPasswordChange = (username = '') => {
        return fetcher({ endpoint: '/team/recovery-password/', method: 'POST', body: JSON.stringify({ username }) })
    };
    const validateToken = (token = '') => {
        return fetcher({ endpoint: '/team/validate-recovery-password/', method: 'POST', body: JSON.stringify({ token }) })
    };
    const setNewPassword = (token = '', password = '') => {
        return fetcher({
            endpoint: '/team/set-recovery-password/', method: 'POST', body: JSON.stringify({
                token,
                new_password: password
            })
        })
    }

    return { validateToken, requestPasswordChange, setNewPassword, loading, error };
};